export enum Environment {
  LOCAL = "local",
  DEV = "dev",
  STAGING = "staging",
  UAT = "uat",
  PROD = "prod",
}
